import { Inject, Injectable } from '@angular/core';

import { CommonsConfigEnvironment, CONFIG_ENVIRONMENT, LogLevel } from '@mirage-projects/cw-models';

@Injectable({
    providedIn: 'root',
})
export class LogService {
    logLevel = this.configEnvironment.logLevel ?? LogLevel.Off;
    priorityLog!: Map<LogLevel, number>;

    constructor(@Inject(CONFIG_ENVIRONMENT) private configEnvironment: CommonsConfigEnvironment) {
        this.priorityLog = new Map();
        this.priorityLog.set(LogLevel.Debug, 0);
        this.priorityLog.set(LogLevel.Info, 1);
        this.priorityLog.set(LogLevel.Warning, 2);
        this.priorityLog.set(LogLevel.Error, 3);
        this.priorityLog.set(LogLevel.Off, 4);

        this.logLevel = (this.logLevel as string).toUpperCase() as LogLevel;
    }

    debug(message: string, obj?: any): void {
        if (this.showLevel(LogLevel.Debug)) {
            if (obj) {
                console.log('%c[CW-DEBUG]', 'color: white; background: blue;', message, obj);
            } else {
                console.log('%c[CW-DEBUG]', 'color: white; background: blue;', message);
            }
        }
    }

    info(message: string, obj?: any): void {
        if (this.showLevel(LogLevel.Info)) {
            if (obj) {
                console.log('%c[CW-INFO]', 'color: white; background: green;', message, obj);
            } else {
                console.log('%c[CW-INFO]', 'color: white; background: green;', message);
            }
        }
    }

    warn(message: string, obj?: any): void {
        if (this.showLevel(LogLevel.Warning)) {
            if (obj) {
                console.warn('%c[CW-WARN]', 'color: white; background: orange;', message, obj);
            } else {
                console.warn('%c[CW-WARN]', 'color: white; background: orange;', message);
            }
        }
    }

    error(message: string, obj?: any): void {
        if (this.showLevel(LogLevel.Error)) {
            if (obj) {
                console.error('%c[CW-ERROR]', 'color: white; background: red;', message, obj);
            } else {
                console.error('%c[CW-ERROR]', 'color: white; background: red;', message);
            }
        }
    }

    private showLevel(level: LogLevel): boolean {
        return (this.priorityLog.get(this.logLevel) as number) <= (this.priorityLog.get(level) as number);
    }
}
